<template>
  <div>
    <div class="mb-3" v-if="type == 'coloumn'">
      <p class="mb-0 fz-14 fw-500">{{ label }}</p>
      <p class="mb-0 fz-14 text-gray-4">{{ value }}</p>
    </div>
    <div class="mb-3 d-flex justify-content-between" v-if="type == 'row'">
      <p class="mb-0 text-gray-4">{{ label }}</p>
      <p class="mb-0 text-gray-4">{{ value }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AtomTable",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      require: true,
    },
    type: {
      type: String,
      default: "coloumn",
    },
  },
};
</script>
